export enum AlertConstants {
  RESET_SHOW_ALERT = 'alert/RESET_SHOW_ALERT',
  SHOW_ALERT = 'alert/SHOW_ALERT',
}
